import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TicketsService {
  constructor(private http: HttpClient) { }

  categories(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/v1/tickets/categories`)
  }

  create(params: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/v1/tickets`, params)
  }
}
